import { useAtomValue } from 'jotai'

import {
  IconArrowUpRight,
  Button,
  Tooltip,
  Link
} from '@sequencehq/core-components'

import { getPortalDomain } from '@sequencehq/utils'

import { getEnvironment } from 'lib/environment/environment'
import {
  invoiceCustomerIdAtom,
  invoiceIdAtom
} from 'Invoices/atoms/invoiceEditing.atom'

export const ButtonViewInCustomerPortal = () => {
  const customerId = useAtomValue(invoiceCustomerIdAtom)
  const invoiceId = useAtomValue(invoiceIdAtom)
  const portalDomain = getPortalDomain(getEnvironment())

  const label = 'View in customer portal'

  return (
    <Tooltip label={label}>
      <Button
        as={Link.Unstyled}
        to={`${portalDomain}/customers/${customerId}/invoices/${invoiceId}`}
        target="_blank"
        rel="noopener noreferrer"
        variant="secondary"
        icon={<IconArrowUpRight color="inherit" />}
        aria-label={label}
        data-testid="header.button.view-in-customer-portal"
      />
    </Tooltip>
  )
}
